export default "__VITE_ASSET__0a5b7194__"